import 'babel-polyfill'
import Vue from 'vue'
import ELEMENT from 'element-ui'

import App from './App'
import router from './router'
import store from './store'
import install from './element-install'
import 'lib-flexible/flexible'

import './styles/element-variables.scss'
import 'normalize.css/normalize.css'
import './styles/index.scss'
import './icons'

// promise finally shim
require('promise.prototype.finally').shim()

// element install
Vue.use(ELEMENT)
install(Vue)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.path.indexOf('product') > -1) {
    document.title = '开放平台·产品中心'
  } else {
    document.title = '高灯云'
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
